module.exports = __webpack_public_path__ + "media/components/page-footer/static/meteo365__logo--white-fd1a02ab6002823dfabdaae03cd5fd20.png";